import React from 'react';
import PropTypes from 'prop-types';
import { FuseLoading } from '@fuse';

/**
 * React Suspense defaults
 * For to Avoid Repetition
 */

const Suspense = props => {
	return <React.Suspense fallback={<FuseLoading {...props.loadingProps} />}>{props.children}</React.Suspense>;
};

Suspense.propTypes = {
	loadingProps: PropTypes.object
};

Suspense.defaultProps = {
	loadingProps: {
		delay: 0
	}
};

export default Suspense;
